import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';

import { Notification } from '../../models';
import { NotificationStore, TokenStore, UserStore } from '../../stores';

import { Card, Drawer, List, Tag } from 'antd';
import { NotificationCard } from './NotificationCard';
import { NotificationModal } from './NotificationModal';
import styled from 'styled-components';

export interface NotificationDrawerProps {
    onClose: () => void;
    notificationStore?: NotificationStore;
    userStore?: UserStore;
    tokenStore?: TokenStore;

}

const ListStyled=styled(List)`
    .ant-tabs-tab-active  {
        color:#000 !important;
    }
`;

@inject('notificationStore')
@inject('userStore')
@inject('tokenStore')
@observer
export class NotificationDrawer extends Component<NotificationDrawerProps> {
    readonly tabList: Array<{
        key: 'Pendientes' | 'Historial';
        tab: 'Pendientes' | 'Historial';
    }> = [
            {
                key: 'Pendientes',
                tab: 'Pendientes'
            },
            {
                key: 'Historial',
                tab: 'Historial'
            }
        ];
    changeTab = (key: string) => {
        const { notificationStore } = this.props;
        notificationStore!.changeKind(key as 'Pendientes' | 'Historial');
    };

    handleNotificationClick = (notification: Notification) => {
        const { notificationStore } = this.props;
        notificationStore!.selectNotification(notification);
    };

    handleSignOutClick = () => {
        this.props.tokenStore!.cerrarSesion();
        this.props.userStore!.limpiarUsuario();
        this.props.onClose!();
    }
    renderNotificationCard = (notification: Notification) => (
        <List.Item>
            <NotificationCard notification={notification} kind="preview" editable={false} />
        </List.Item>
    );

    render() {
        const { onClose, notificationStore } = this.props;
        const {
            kind,
            notificationsCurrent,
            currentNotificationCount,
            notificationsPast,
            showDrawer,
            seenDrawer,
            openModal
        } = notificationStore!;
        const dataSource = kind === 'Pendientes' ? notificationsCurrent : notificationsPast;
        const bandera = (currentNotificationCount > 0)
        const visible = bandera === true ? bandera :
            (showDrawer || (bandera && !seenDrawer));

        return (
            <Drawer width={640} placement="right" visible={visible} onClose={onClose} closable={!bandera}
            >
                <Tag visible={bandera}
                    onClick={this.handleSignOutClick}
                    style={{
                        marginLeft: '450px', fontSize: '13px',
                        borderBottomColor: '#6e6e6e', backgroundColor: 'white',
                        color: '#6e6e6e', borderTopColor: 'white', borderRightColor: 'white', borderLeftColor: 'white'
                    }}

                >Cerrar Sesión</Tag>
                <Card
                    title="Notificaciones"
                    tabList={this.tabList}
                    activeTabKey={kind}
                    onTabChange={this.changeTab}
                    bordered={false}
                >
                    <List
                        itemLayout="vertical"
                        dataSource={dataSource}
                        renderItem={this.renderNotificationCard}
                    />
                    {openModal && <NotificationModal />}
                </Card>
            </Drawer>
        );
    }
}
